/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STCommonComponent {
  async GetSessionConstants() : Promise<st.SessionConstants> {
    return await componentApi.call('st', 'st-common', 'STCommonComponent', 'GetSessionConstants', {
    });
  }
}
export default new STCommonComponent()
